import {WhiteBgButtonThin} from '@packages/ui';
import type {z} from 'zod';
import type {
  RecruitmentSchema,
  RecruitmentType,
  RecruitmentsSchema,
} from '../../../../../core/entities/recruitment/schema';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {
  RecruitmentTagListItem,
  RecruitmentTypeListItem,
} from '../../../../recruitment/components/RecruitmentTag';
import {Schedules} from './Schedules';

type Props = {
  recruitments: z.infer<typeof RecruitmentsSchema>;
};

export const RecruitmentList: React.FC<Props> = ({recruitments}: Props) => {
  return (
    <div>
      <div>
        {recruitments.map((recruitment) => {
          return (
            <RecruitmentComponent
              key={recruitment.id}
              recruitment={recruitment}
            />
          );
        })}
      </div>
    </div>
  );
};

const RecruitmentComponent: React.FC<{
  recruitment: z.infer<typeof RecruitmentSchema>;
}> = ({recruitment}) => {
  const {isPC} = useMediaQuery();
  const isNotArchive = recruitment.category !== 'archive';

  return (
    <div className="mb-24 [&:nth-last-child(1)]:mb-0 pb-24 [&:nth-last-child(1)]:pb-0 border-b-[1px] border-line border-collapse [&:nth-last-child(1)]:border-b-0">
      <div className="flex pc:block">
        <div className={isPC ? '' : 'w-[74%]'}>
          <ul className="flex flex-wrap pc:flex-nowrap w-full pc:w-auto">
            <li className="mr-8">
              <RecruitmentTypeListItem
                recruitmentType={recruitment.type as RecruitmentType}
              />
            </li>
            {recruitment.tags.map((tag) => {
              return (
                <li key={`tag-${tag.id}`} className="mr-8">
                  <RecruitmentTagListItem recruitmentTag={tag} />
                </li>
              );
            })}
            {recruitment.groupedJobTypes.map((jobType) => {
              return (
                <li key={`jobType-${jobType.id}`} className="mr-8">
                  <p className="bg-black-3 text-xs text-white py-2 w-[72px] text-center">
                    {jobType.name}
                  </p>
                </li>
              );
            })}
            <li className="mr-8">
              <p className="bg-black-3 text-xs text-white py-2 w-[72px] text-center">
                {recruitment.targetYear > 0
                  ? `${recruitment.targetYear}卒`
                  : '学年不問'}
              </p>
            </li>
          </ul>
          <div className="mt-12">
            <CommonLink
              className="text-[13px] pc:text-md text-black-1 pc:text-link-1 font-bold hover:opacity-80"
              href={recruitment.detailPageURL}
            >
              {recruitment.title}
            </CommonLink>
            <p className="text-sm text-black-3 mt-8">
              {recruitment.companies[0]?.name}
            </p>
          </div>
        </div>
        {!isPC && isNotArchive && (
          <div className="w-[26%] ml-auto">
            <img
              src={recruitment.companies[0]?.logoURLs['140x105']}
              alt={recruitment.companies[0]?.name}
              className="object-cover"
            />
          </div>
        )}
      </div>
      {isPC && recruitment.schedules.length > 0 && (
        <Schedules schedules={recruitment.schedules} isSp={false} />
      )}
      {!isPC && (
        <div>
          <WhiteBgButtonThin
            isPrimary={false}
            label={'募集詳細を見る'}
            onClick={() => {
              location.href = recruitment.detailPageURL;
            }}
            className="w-full mt-12"
          />
        </div>
      )}
    </div>
  );
};
